import { atom } from 'jotai';

import { DeviceId } from '@service-initiation/shared-clients-tech-care-services';

import { deviceDetailsAsyncAtom } from './deviceDetailsAsyncAtom';
import { selectedDeviceTypeAsyncAtom } from './selectedDeviceTypeAsyncAtom';

export const isOtherDeviceAsyncAtom = atom(async (get) => {
  const deviceType = await get(selectedDeviceTypeAsyncAtom);
  const deviceDetails = await get(deviceDetailsAsyncAtom);
  return (
    deviceType?.id === DeviceId.Other &&
    (deviceDetails?.id === DeviceId.Other ||
      deviceDetails?.id === DeviceId.OtherChild)
  );
});
